// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__MXBVD","size-S":"Form_size-S__uvYYU","size-M":"Form_size-M__5Ufpo","size-L":"Form_size-L__dCYtn"};